import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ClientApi, Organization } from '../client-api.service';
import { ArrayUtil } from './array-util';
import { formatPhone } from './formatting';

interface KeyUrlPair {
  key: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private static readonly orgSorter =
    ArrayUtil.compareSelectorStringsFuncFactory<Organization>(x => x.name || '', { ignoreCase: true });

  /** gets orgs */
  readonly orgs$ = this.clientApi.getOrgs().pipe(
    map(x => {
      x.result;
      return x.result?.sort(AppService.orgSorter) ?? [];
    }),
    tap(x => console.log(x)),
    shareReplay(1)
  );

  readonly orgMap$ = this.orgs$.pipe(
    map(x => new Map(x.map(y => [y.orgCode, y]))),
    shareReplay(1)
  );

  /** All social media services */
  readonly socialMediaServices$ = this.clientApi.getSocialMediaServices().pipe(map(x => x.result), shareReplay(1));

  /** All social links for orgs. */
  readonly orgSocLinksMap$ = combineLatest([this.orgs$, this.socialMediaServices$]).pipe(
    map(([orgs, socMedSvcs]) => {
      const defaultOrg = orgs.find(x => x.orgCode === environment.defaultOrgCode);
      const orgSocLinks = orgs.map((org) => {
        const socLinks = socMedSvcs.map(socSvc => {
            const key = socSvc.applicationKey || '';
            let url = org?.socialUrls?.[key];
            if (!url && socSvc.useDefaultIfMissing) {
              url = defaultOrg?.socialUrls?.[key];
            }
            return { key, url };
          })
          .filter((x): x is KeyUrlPair => !!x.key && !!x.url)
          .reduce((cur, { key, url}) => ({ ...cur, [key]: url }), {} as { [key: string]: string });
        return [ org.orgCode, socLinks ] as [string, { [key: string]: string } ];
      });
      return new Map(orgSocLinks);
    }),
    shareReplay(1)
  );

  
  readonly user$ = this.clientApi.getCurrentUser().pipe(map(x => x.result), shareReplay(1));

  constructor(private clientApi: ClientApi) { }

}
